import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { CriticalStandard } from '@/domain/types/collections';
import useGetDocument from '@/domain/use-cases/get-document';
import AlertMessage from '@/presentation/components/alert-message';
import CommentsDetailDocument from '@/presentation/components/detail-document/comments';
import HeaderDetailDocument from '@/presentation/components/detail-document/header';
import StatsDetailDocument from '@/presentation/components/detail-document/stats';
import FormAddDocument from '@/presentation/components/form-add-document';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const CriticalStandardsDetailsPage = () => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data,
    error,
    isLoading,
    updateDocument,
    deleteDocument,
    deleteComment,
    comments,
  } = useGetDocument<CriticalStandard>(DOCUMENTS_DB.CRITICAL_STANDARS, id);

  const handleDelete = async () => {
    try {
      await deleteDocument();
      toast.success('Estándar crítico eliminado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/critical-standars');
    } catch (error) {
      console.log(error);
      toast.error('Error al eliminar el estándar crítico', {
        theme: 'colored',
      });
    }
  };

  const handleSave = async (updateData: CriticalStandard | any) => {
    try {
      const updatedData = { ...data, ...updateData };
      console.log(updatedData);
      await updateDocument(updatedData);
      toast.success('Estándar crítico actualizado correctamente', {
        theme: 'colored',
      });
    } catch (error) {
      console.log(error);
      toast.error('Error al actualizar el estándar crítico', {
        theme: 'colored',
      });
    }
  };

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No data</div>;

  return (
    <div className="p-4 flex flex-row md:flex-col gap-8">
      <HeaderDetailDocument
        title={data.title}
        handleDelete={() => setIsAlertMessageOpen(true)}
      />

      <StatsDetailDocument data={data} />

      <FormAddDocument
        onSave={handleSave}
        document={data}
        contentType="critical-standard"
      />

      <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
        <CommentsDetailDocument data={comments} deleteComment={deleteComment} />
      </div>

      <AlertMessage
        title="Eliminar Estándar Crítico"
        message="¿Estás seguro de querer eliminar este estándar crítico?"
        onConfirm={handleDelete}
        onCancel={() => setIsAlertMessageOpen(false)}
        isOpen={isAlertMessageOpen}
      />
    </div>
  );
};

export default CriticalStandardsDetailsPage;
